<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Stock Hold/Release</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div
    class="flex flex-col gap-1 md:flex-row"
    role="tablist"
    aria-label="Stock hold mode"
  >
    <button
      type="button"
      role="tab"
      [attr.aria-selected]="selectedTab === 'single'"
      [ngClass]="
        selectedTab === 'single' ? 'tab-item_selected' : 'tab-item'
      "
      (click)="changeTab('single')"
    >
      Single Hold/Release
    </button>
    <button
      type="button"
      role="tab"
      [attr.aria-selected]="selectedTab === 'batch'"
      [ngClass]="
        selectedTab === 'batch' ? 'tab-item_selected' : 'tab-item'
      "
      (click)="changeTab('batch')"
    >
      Batch Hold/Release
    </button>
  </div>
  <section
    class="content-container__tabs"
    [hidden]="selectedTab !== 'single'"
  >
    <h2 class="sub-heading w-full border-b">Single Hold/Release</h2>
    <fieldset [disabled]="singleBusy" class="min-w-0">
      <app-data-form
        [dataFields]="searchFormFields"
        (clickSearch)="searchByVIN()"
        (updateFields_child)="onSingleChange($event)"
      />
      <div
        class="mt-2 flex w-full flex-col gap-1 md:w-fit md:flex-row"
      >
        <button
          class="shorter-btn misc-btn"
          [disabled]="!loadedVin || registered"
          (click)="updateEntry()"
        >
          <fa-icon [icon]="faPencil" class="mr-1" />Update
        </button>
        <button
          class="shorter-btn delete-btn"
          [disabled]="!loadedVin"
          (click)="printEntry()"
        >
          <fa-icon [icon]="faPrint" class="mr-1" />Print
        </button>
        <button class="shorter-btn clear-btn" (click)="clearEntry()">
          <fa-icon [icon]="faEraser" class="mr-1" />Clear
        </button>
      </div>
    </fieldset>
    <p *ngIf="registered" role="status" class="mt-2 text-red-600">
      This VIN Number is registered and cannot be updated.
    </p>
  </section>
  <section
    class="content-container__tabs"
    [hidden]="selectedTab !== 'batch'"
  >
    <h2 class="sub-heading w-full border-b">Batch Hold/Release</h2>
    <fieldset [disabled]="batchBusy" class="min-w-0">
      <app-data-form
        [dataFields]="batchFormFields"
        (updateFields_child)="onBatchChange($event)"
      />
      <div
        class="mt-2 flex w-full flex-col gap-1 pb-4 md:w-fit md:flex-row"
        *ngIf="vehicleList.length"
      >
        <button class="shorter-btn misc-btn" (click)="updateBatch()">
          <fa-icon [icon]="faPencil" class="mr-1" />Update
        </button>
        <button class="shorter-btn misc-btn" (click)="checkAll()">
          <fa-icon [icon]="faSquareCheck" class="mr-1" />Check All
        </button>
        <button class="shorter-btn misc-btn" (click)="uncheckAll()">
          <fa-icon [icon]="faSquare" class="mr-1" />Uncheck All
        </button>
      </div>
      <p *ngIf="batchMessage" role="status" class="my-4">
        {{ batchMessage }}
      </p>
      <div *ngIf="vehicleList.length" class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[48rem]"
          [tableHeaders]="tableHeaders_vehicleList"
          [tableEntries]="vehicleList"
          [pagination]="false"
        />
      </div>
    </fieldset>
  </section>
</section>
